import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {ThemeProvider} from 'styled-components';
import {I18nextProvider} from 'react-i18next';
import jQuery from 'jquery';
import ScreenRouter from './screens/router';
import store from './store';
import i18n from './i18n';
import 'bootstrap';
import './icons';
import './style.scss';

window.$ = jQuery;

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={{primary: '#284a41'}}>
        <ScreenRouter />
      </ThemeProvider>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);
